import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";
import { IShow } from "@eagerdog/interfaces";
import { buildCwagsFeoRow } from "./cwagsFeo";

export namespace CWagsScent {
  export const getForm = (show?: IShow): IEventRegisterRow[] => {
    const filterOptions = (showElement: string, options: Array<{ value: string; id: string }>) => {
      if (!show?.show_elements || show.show_elements.length === 0) {
        return options;
      }

      const matchingElements = show.show_elements.filter((se) => se.show_element === showElement);
      if (matchingElements.length === 0) {
        return [];
      }

      // Backward compatibility: if section exists without explicit levels, expose all options.
      const hasSectionWithoutLevels = matchingElements.some(
        (se) => !se.level || se.level === "" || se.level === "None"
      );
      if (hasSectionWithoutLevels) {
        return options;
      }

      const selectedLevels = new Set(matchingElements.map((se) => se.level));
      return options.filter((option) => selectedLevels.has(option.id));
    };

    const scentOptions = filterOptions(Constants.dog_class_element.scent, [
      { value: Constants.dog_class_element_level.patrols_1, id: Constants.dog_class_element_level.patrols_1 },
      { value: Constants.dog_class_element_level.detective_2, id: Constants.dog_class_element_level.detective_2 },
      { value: Constants.dog_class_element_level.investigator_3, id: Constants.dog_class_element_level.investigator_3 },
      { value: Constants.dog_class_element_level.super_sleuth_4, id: Constants.dog_class_element_level.super_sleuth_4 },
      { value: Constants.dog_class_element_level.private_investigator, id: Constants.dog_class_element_level.private_investigator },
      { value: Constants.dog_class_element_level.detective_diversions, id: Constants.dog_class_element_level.detective_diversions },
    ]);

    const rangerOptions = filterOptions(Constants.dog_class_element.ranger, [
      { value: Constants.dog_class_element_level.scent_ranger_1, id: Constants.dog_class_element_level.scent_ranger_1 },
      { value: Constants.dog_class_element_level.scent_ranger_2, id: Constants.dog_class_element_level.scent_ranger_2 },
      { value: Constants.dog_class_element_level.scent_ranger_3, id: Constants.dog_class_element_level.scent_ranger_3 },
      { value: Constants.dog_class_element_level.scent_ranger_4, id: Constants.dog_class_element_level.scent_ranger_4 },
      { value: Constants.dog_class_element_level.scent_ranger_5, id: Constants.dog_class_element_level.scent_ranger_5 },
    ]);

    const dasherOptions = filterOptions(Constants.dog_class_element.dasher, [
      { value: Constants.dog_class_element_level.dasher_scent_3, id: Constants.dog_class_element_level.dasher_scent_3 },
      { value: Constants.dog_class_element_level.dasher_scent_4, id: Constants.dog_class_element_level.dasher_scent_4 },
      { value: Constants.dog_class_element_level.dasher_scent_5, id: Constants.dog_class_element_level.dasher_scent_5 },
      { value: Constants.dog_class_element_level.dasher_scent_6, id: Constants.dog_class_element_level.dasher_scent_6 },
    ]);

    const formRows: IEventRegisterRow[] = [];

    // Regular row per element, followed by its FEO row when the show offers FEO.
    const pushElementRows = (element: string, options: Array<{ value: string; id: string }>) => {
      if (options.length === 0) {
        return;
      }

      formRows.push({
        inputs: [{
          type: "checkbox",
          multiSelect: true,
          label: element,
          options,
        }]
      });

      const feoRow = buildCwagsFeoRow(show, element, options);
      if (feoRow) {
        formRows.push(feoRow);
      }
    };

    pushElementRows(Constants.dog_class_element.scent, scentOptions);
    pushElementRows(Constants.dog_class_element.ranger, rangerOptions);
    pushElementRows(Constants.dog_class_element.dasher, dasherOptions);

    return formRows;
  };

  export const form: IEventRegisterRow[] = getForm();
}
